import {ICartPosition, IPromotionalItem, PromotionalsFactory} from "../../../typescript-library";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {getShopId} from "../../lib/getShopId";
import {useCartContext} from "../CartContextProvider/CartContextProvider";
import ItemThumb from "./ItemThumb";
import * as Sentry from "@sentry/browser";
import styles from "./ItemRow.module.scss";

let promotionItemsCache: IPromotionalItem[] = [];

const PromotionalItems: React.FC = () => {
  const {cart} = useCartContext();
  const [promoItems, setPromoItems] = React.useState<IPromotionalItem[] | null>(null);
  const promotionalItems = React.useRef<IPromotionalItem[]>([]);
  const {t} = useTranslation();
  const itemPositions = cart.positions.filter((pos: ICartPosition) => pos.type === "Item");
  const mounted = React.useRef<boolean>(true);
  const removeItemsAlreadyIncludedInCart = (items: IPromotionalItem[]) => {
    return items.filter((candidate) => {
      return !itemPositions.find((position) => {
        return position.item && position.item.itemId === candidate.promotionalItems.itemId;
      });
    });
  };

  React.useEffect(() => {
    if (promotionItemsCache.length) {
      promotionalItems.current = promotionItemsCache;
      setPromoItems(removeItemsAlreadyIncludedInCart(promotionItemsCache));
    } else {
      PromotionalsFactory.retrievePromotionals(getShopId()).then((items) => {
        // if this happens, the component did unmount before the items where loaded
        if (!mounted.current) {
          return;
        }
        promotionItemsCache = items;
        promotionalItems.current = items;
        setPromoItems(removeItemsAlreadyIncludedInCart(items));
      }, Sentry.captureException);
    }

    return () => {
      mounted.current = false;
    };
  }, []);

  React.useEffect(() => {
    setPromoItems(removeItemsAlreadyIncludedInCart(promotionalItems.current));
  }, [cart.positions.length]);

  if (!promoItems || !promoItems.length) {
    return null;
  }

  return (
    <div className={styles.promotionalItemsWrapper}>
      {promoItems.map((promotionLine) => {
        const {itemId, title, url} = promotionLine.promotionalItems;
        const {formatted} = promotionLine.freeThreshold;

        return (
          <div key={itemId} className={`${styles.itemRow} ${styles.promotional}`}>
            <ItemThumb item={promotionLine.promotionalItems} />
            <div className={styles.itemDetails}>
              <p>
                <a className={styles.titleLink} href={url} title={t("general.open--title", {title})}>
                  {title}
                </a>
                <br />
                {t("cart.freeFromCertainValue--formatted", {formatted})}
              </p>
              <strong className={styles.right}>{t("general.freeShipping")}</strong>
              <span className={styles.addToCart} onClick={() => void cart.addItem(itemId)}>
                {t("general.addToCart")}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PromotionalItems;
